<template>
  <div>
    <div class="bk_main inner">
      <div class="gwxq" id="gwxq">
        <div id="gwnr">
          <!-- <div class="gwxq_bt">.</div> -->
          <!-- <div class="gwxq_sj">{{choosePostNoticeInfo.publishTime}}</div> -->
          <div class="gwxq_nr" v-html="choosePostNoticeInfo.content"></div>
        </div>
        <div
          class="gwxq_button"
          v-if="choosePostNoticeInfo.status == 1 && choosePostNoticeInfo.open"
          @click="signUp()"
        >
          报名参加
        </div>
      </div>
    </div>
    <sign-up ref="choosePostSignUp" :recruitId="id" :showSignUp.sync="showSignUp" />

    <el-dialog title="用户须知" :visible.sync="centerDialogVisible" center>
      <span class="user-agreement">
        <hr />
        欢迎使用国经人力招聘网站，感谢您选择我们。<br />
        该网站提供的服务包括职位发布、简历投递、在线沟通等功能，用户可以自主选择使用。<br />
        为了保障招聘企业和应聘者的合法权益，我们制定了以下规则：<br />
        1.
        发布招聘信息的企业必须为具有法人资格的合法经营单位，且必须提供有效的营业执照等相关信息；<br />
        2.
        发布招聘信息的企业必须如实填写招聘职位的相关信息，并保证招聘信息的真实性和准确性；<br />
        3. 应聘者必须如实填写个人简历，并保证个人信息的真实性和准确性；<br />
        4. 任何企业和个人不得在网站上发布虚假招聘信息或盗用他人身份信息应聘；<br />
        5. 本网站提供的所有服务均需符合国家法律法规的规定。<br />
        为了更好地使用本网站，我们提供了以下服务：<br />
        1. 职位搜索：用户可以根据自己的需求，搜索感兴趣的职位；<br />
        2. 简历投递：用户可以将自己的简历投递给心仪的企业；<br />
        3.
        在线沟通：用户可以与企业在线沟通，了解更多职位信息和面试安排等信息。<br />
        为了更好地保障用户的权益，我们制定了以下措施：<br />
        1. 设置了投诉举报渠道，方便用户举报违规行为；<br />
        2 对违规行为将采取严肃处理，情节严重的将移交有关部门处理；<br />
        3. 我们会定期对网站进行安全检测和漏洞扫描，以确保用户的信息安全。<br />
        如果您在使用本网站过程中遇到任何问题或疑问，请随时联系我们的客服人员，我们将尽快为您解决。<br />
        本网站会不断改进和更新，敬请随时关注我们的最新动态。<br />
      </span>
      <span class="user-checkbox">
        <el-checkbox
          name="我以详读用户须知"
          v-model="userButton"
          @change="confirmUserButton"
          >我以详读用户须知</el-checkbox
        >
      </span>
      <span slot="footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="disabled" @click="confirmButton"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
// import SignUp from "@/components/choosePostSign.vue";
// import SignUp from "@/components/choosePostSign1.vue";
import SignUp from "@/components/choosePostSign2.vue";
export default {
  components: { SignUp },
  data() {
    return {
      id: "",
      showSignUp: false,
      choosePostNoticeInfo: {},
      centerDialogVisible: false, // 用户须知 弹窗
      userButton: false, // 读完 用户须知 按钮(确认按钮)
      disabled: true, // 确认按钮
    };
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getRecruitNoticeDetail();
    }
  },
  mounted() {},
  watch: {
    $route() {
      if (this.$route.query.id) {
        this.id = this.$route.query.id;
        this.getRecruitNoticeDetail();
      }
    },
  },
  methods: {
    getRecruitNoticeDetail() {
      let _this = this;
      let parmas = {
        id: _this.id,
        // Authentication: _this.$cookies.get(_this.$commons.User.Authentication),
      };
      _this.$api.choosePostRecruitNotice
        .getChoosePostInfoById(parmas)
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            _this.choosePostNoticeInfo = res.data;
          }
        })
        .catch(() => {});
    },
    signUp() {
      let _this = this;
      // _this.$refs.signUp.showSignUp = true;
      // _this.centerDialogVisible = true; // 用户须知弹窗(暂时隐藏)
      _this.checkSign(); // 没有弹窗(直接进入到单位报名界面)
    },
    confirmUserButton() {
      let _this = this;
      if (_this.userButton) {
        // 当选中 checkbox 时执行的代码
        _this.userButton = true;
        _this.disabled = false;
      } else {
        // 当取消选中 checkbox 时执行的代码
        _this.userButton = false;
        _this.disabled = true;
      }
    },
    confirmButton() {
      let _this = this;
      _this.centerDialogVisible = false;
      _this.checkSign();
    },
    checkSign() {
      let _this = this;
      _this.$api.choosePostRecruitNotice
        .checkSign({ recruitId: _this.id })
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            _this.$refs.choosePostSignUp.showSignUp = true;
            // _this.$refs.signUp.getSignupInfo();
            // _this.$refs.signUp.getUserInfo();
            // _this.$refs.signUp.getPostList();
          } else {
            _this.$layer.alert(res.msg);
          }
        })
        .catch(() => {})
        .finally(() => {});
    },
  },
};
</script>
  
  <style>
/* .detail p{
    line-height: 1.75em !important;
  
  } */
/* .gwxq_nr img {
  width: 100% !important;
} */

.user-agreement {
  font-size: 15px;
  /* 字体大小 */
  line-height: 35px;
  /* 文本上下间距 */
}

.user-checkbox {
  display: flex;
  /* 弹性布局 */
  justify-content: center;
  /* 控制子元素在主轴（水平方向或垂直方向）上的排列方式 */
  align-items: center;
  /* 相对于弹性容器的纵轴居中对齐 */
}
</style>
  


// WEBPACK FOOTER //
// src/view/choosePostNotice/recruitDetail.vue